import { inject } from '@angular/core';
import { toObservable } from '@angular/core/rxjs-interop';
import { CanActivateFn, Router } from '@angular/router';
import { filter, map } from 'rxjs';
import { AuthStore } from '../store/auth-store';

export const authGuard: CanActivateFn = (route, state) => {
  const authStore = inject(AuthStore);
  const router = inject(Router);

  // Wait until loading is done, then emit canActivate value once.
  return toObservable(authStore.isDoneLoading).pipe(
    filter(isDone => isDone),
    map(() => {
      if (state.url === '/') {
        if (!authStore.isAuthenticated()) {
          return router.createUrlTree(['validityCheck']);
        }

        // Without a role no other route is accessible, so the permission
        // guard would keep sending the user back here.
        return router.createUrlTree([
          authStore.roles().length > 0 ? 'dashboard' : 'no-access',
        ]);
      }
      if (!authStore.isAuthenticated()) {
        authStore.login(state.url);
        return false;
      }
      return true;
    })
  );
};
